import { AxiosPromise } from 'axios'

import api from '@config/api'

export function getSaleIndicatorsData(data: any, page: number): AxiosPromise {
  return api.post('v1/KPIVenda', data, {
    params: {
      pagination: JSON.stringify({
        actualPage: page,
        rows: 1000
      })
    }
  })
}

export function getSaleIndicatorsDataAll(
  data: any,
  _page: number
): AxiosPromise {
  return api.post('v1/KPIVenda', data, {})
}
export function getSaleIndicatorProductsData(data: any): AxiosPromise {
  return api.post('v1/KPIVenda/Produtos', data)
}

export function postSaleIndicatorExportData(data: any): AxiosPromise {
  return api.post('v1/KPIVenda/Exportar', data)
}

export function postSaleIndicatorGraphicData(
  data: any,
  type: string
): AxiosPromise {
  return api.post(`v1/KPIVenda/Grafico/${type || '1'}/Tipo`, data)
}

export function postSaleIndicatorExportModalData(data: any): AxiosPromise {
  return api.post('v1/KPIVenda/Produtos/Exportar', data)
}

export function getStorageIndicatorsData(
  data: any,
  page: number
): AxiosPromise {
  return api.post('v1/KPIEstoque', data, {
    params: {
      pagination: JSON.stringify({
        actualPage: page,
        rows: 1000
      })
    }
  })
}

export function getStorageIndicatorsDataALL(data: any): AxiosPromise {
  return api.post('v1/KPIEstoque', data, {})
}

export function getStorageIndicatorProductsData(
  data: any,
  page: number
): AxiosPromise {
  return api.post('v1/KPIEstoque/Produtos', data, {
    params: {
      pagination: JSON.stringify({
        actualPage: page,
        rows: 200
      })
    }
  })
}
export function getStorageIndicatorProductsDataAll(data: any): AxiosPromise {
  return api.post('v1/KPIEstoque/Produtos', data, {})
}

export function postStorageIndicatorExportData(data: any): AxiosPromise {
  return api.post('v1/KPIEstoque/Exportar', data)
}

export function postStorageIndicatorExportDataModal(data: any): AxiosPromise {
  return api.post('v1/KPIEstoque/Produtos/Exportar', data)
}

export function postStorageIndicatorGraphicData(data: any): AxiosPromise {
  return api.post('v1/KPIEstoque/Grafico', data)
}

export function getLogisticIndicatorsData(
  data: any,
  page: number
): AxiosPromise {
  return api.post('v1/KPILogistica', data, {
    params: {
      pagination: JSON.stringify({
        actualPage: page,
        rows: 1000
      })
    }
  })
}

export function getLogisticIndicatorsDataAll(data: any): AxiosPromise {
  return api.post('v1/KPILogistica', data, {})
}
export function getLogisticIndicatorsProductData(data: any): AxiosPromise {
  return api.post('v1/KPILogistica/Produtos', data)
}

export function postLogisticIndicatorExportData(data: any): AxiosPromise {
  return api.post('v1/KPILogistica/Exportar', data)
}

export function postLogisticIndicatorExportModalData(data: any): AxiosPromise {
  return api.post('v1/KPILogistica/Produtos/Exportar', data)
}

export function postLogisticIndicatorGraphicData(data: any): AxiosPromise {
  return api.post('v1/KPILogistica/Grafico', data)
}

export function getRuptureIndicatorsData(
  data: any,
  page: number
): AxiosPromise {
  return api.post('v1/KPIRuptura', data, {
    params: {
      pagination: JSON.stringify({
        actualPage: page,
        rows: 1000
      })
    }
  })
}

export function postRuptureIndicatorExportData(data: any): AxiosPromise {
  return api.post('v1/KPIRuptura/Exportar', data)
}

export function getRuptureIndicatorsProductData(
  data: any,
  page: number
): AxiosPromise {
  return api.post('v1/KPIRuptura/Produtos', data, {
    params: {
      pagination: JSON.stringify({
        actualPage: page,
        rows: 200
      })
    }
  })
}

export function getRuptureIndicatorsProductDataAll(data: any): AxiosPromise {
  return api.post('v1/KPIRuptura/Produtos', data, {})
}

export function getRuptureIndicatorsDataAll(data: any): AxiosPromise {
  return api.post('v1/KPIRuptura', data, {})
}

export function postRuptureIndicatorExportModalData(data: any): AxiosPromise {
  return api.post('v1/KPIRuptura/Produtos/Exportar', data)
}

export function postRuptureIndicatorGraphicData(
  data: any,
  _day: any
): AxiosPromise {
  return api.post('v1/KPIRuptura/Grafico', data)
}

export function getFilterProduct(params: any): AxiosPromise {
  return api.post('v1/KPIEstoque/Produtos/Filtro', params)
}

export default {
  getSaleIndicatorsData,
  getSaleIndicatorProductsData,
  postSaleIndicatorExportData,
  postSaleIndicatorGraphicData,
  postSaleIndicatorExportModalData,
  getStorageIndicatorsData,
  getStorageIndicatorProductsData,
  postStorageIndicatorExportData,
  postStorageIndicatorExportDataModal,
  postStorageIndicatorGraphicData,
  getLogisticIndicatorsData,
  getLogisticIndicatorsProductData,
  postLogisticIndicatorExportData,
  postLogisticIndicatorExportModalData,
  postLogisticIndicatorGraphicData,
  getRuptureIndicatorsData,
  postRuptureIndicatorExportData,
  getRuptureIndicatorsProductData,
  postRuptureIndicatorExportModalData,
  postRuptureIndicatorGraphicData,
  getSaleIndicatorsDataAll,
  getStorageIndicatorsDataALL,
  getLogisticIndicatorsDataAll,
  getRuptureIndicatorsProductDataAll,
  getStorageIndicatorProductsDataAll,
  getRuptureIndicatorsDataAll,
  getFilterProduct
}
